import CustomComponent from '../CustomComponent';

export class SectionHeaderComponent extends CustomComponent {
  static key = 'lta-section-header';

  constructor() {
    super();
    this.state = {};
  }

  static get observedAttributes() {
    return [
      'title',
      'url',
      'show-watermark',
      'show-button',
      'show-logo',
      'button-text',
      'classes',
      'title-class',
      'wrapper-classes',
      'inner-classes',
      'button-classes',
      'header-alignment'
    ];
  }

  /*
   * Utility to convert boolean-like attribute values to real booleans.
   * Treats absence of attribute or explicit "false" (case-insensitive) as false.
   */
  _toBool(val) {
    if (val === undefined || val === null) return false;
    if (typeof val === 'string') {
      return val.toLowerCase() !== 'false';
    }
    return Boolean(val);
  }

  render() {
    const {
      title = '',
      url = '',
      classes = '',
      titleClass = '',
      wrapperClasses = '',
      innerClasses = '',
      buttonClasses = '',
      buttonText: _buttonText,
      headerAlignment = 'left',
      showWatermark: _showWatermark,
      showButton: _showButton,
      showLogo: _showLogo
    } = this.props;

    const buttonText = _buttonText || 'View All';
    const showWatermark = this._toBool(_showWatermark);
    const showButton = this._toBool(_showButton);
    const showLogo = this._toBool(_showLogo);

    // Build class names mirroring logic in Preact component
    const classNames = [
      'lta-section-header',
      headerAlignment === 'right' && !showButton ? 'lta-section-header--right' : '',
      headerAlignment === 'center' && !showButton ? 'lta-section-header--center' : '',
      classes
    ]
      .filter(Boolean)
      .join(' ');

    const innerClassList = ['lta-section-header__inner', innerClasses].filter(Boolean).join(' ');
    const wrapperClassList = ['l-grid', 'l-grid--py-0', 'u-px-0', wrapperClasses].filter(Boolean).join(' ');
    const buttonClassList = [
      'lta-section-header__button',
      'text-decoration-underline',
      'u-caption1',
      buttonClasses
    ].filter(Boolean).join(' ');
    const buttonLinkClassList = [
      'lta-section-header__button-link',
      'text-decoration-underline',
      'u-caption1',
      buttonClasses
    ]
      .filter(Boolean)
      .join(' ');
    const titleClassList = ['lta-section-header__header', titleClass].filter(Boolean).join(' ');

    const renderButton = size => {
      if (!showButton || !url) return '';
      const cls = size === 'lg' ? buttonClassList : buttonLinkClassList;
      return `
      <a href="${url}" class="${cls}" aria-label="${buttonText}">
        ${buttonText}
        <svg class="lta-icon js-lta-text-input--btn-icon u-ml-0" width="1.5em" height="1.5em" style="color:currentColor;" fill="currentColor" alt="caret-left-fill" aria-hidden="true">
          <use xlink:href="/static/images/icons/lta-icons.svg#caret-left-fill"></use>
        </svg>
      </a>`;
    };

    return `
      <div class="${classNames}">
        <div class="lta-section-header__outer">
          ${showWatermark ? `<div class="lta-section-header__watermark u-mb-4" aria-hidden="true">${title} ${title} ${title} ${title}</div>` : ''}
          <div class="${wrapperClassList}">
            <div class="${innerClassList}">
              <div class="${titleClassList}">${title}</div>
              ${renderButton('lg')}
            </div>
          </div>
        </div>
        ${renderButton('md')}
      </div>
    `;
  }
}

export default SectionHeaderComponent;